import React from 'react';
import '../css/statusBadge.css';

export type BadgeVariant =
  | 'published'
  | 'unpublished'
  | 'draft'
  | 'new'
  | 'reviewed'
  | 'shortlisted'
  | 'interviewed'
  | 'rejected'
  | 'hired';

export interface StatusBadgeProps {
  variant: BadgeVariant;
  label?: string;
}

const BADGE_CONFIG = {
  published: {
    label: 'Published',
    dotColor: '#2AA63C',
    bgColor: '#F3FFF6',
    textColor: '#2AA63C',
  },
  unpublished: {
    label: 'Unpublished',
    dotColor: '#8A8B8F',
    bgColor: '#F2F2F3',
    textColor: '#8A8B8F',
  },
  draft: {
    label: 'Draft',
    dotColor: '#FF9F0A',
    bgColor: '#FFF3D6',
    textColor: '#B97000',
  },
  new: {
    label: 'New',
    dotColor: '#2AA63C',
    bgColor: '#F3FFF6',
    textColor: '#2AA63C',
  },
  reviewed: {
    label: 'Reviewed',
    dotColor: '#2388FF',
    bgColor: '#C3DDFF',
    textColor: '#2388FF',
  },
  shortlisted: {
    label: 'Shortlisted',
    dotColor: '#9747FF',
    bgColor: '#F0E4FF',
    textColor: '#9747FF',
  },
  interviewed: {
    label: 'Interviewed',
    dotColor: '#FF7411',
    bgColor: '#FFEBDD',
    textColor: '#FF7411',
  },
  rejected: {
    label: 'Rejected',
    dotColor: '#FE566B',
    bgColor: '#FFECEF',
    textColor: '#FE566B',
  },
  hired: {
    label: 'Hired',
    dotColor: '#07AEDD',
    bgColor: '#DEF8FF',
    textColor: '#07AEDD',
  },
} satisfies Record<BadgeVariant, { label: string; dotColor: string; bgColor: string; textColor: string }>;

const StatusBadge: React.FC<StatusBadgeProps> = ({ variant, label }) => {
  const config = BADGE_CONFIG[variant];

  return (
    <span
      className="scl--cms-components-statusBadge"
      style={{
        backgroundColor: config.bgColor,
        color: config.textColor,
      }}
    >
      <span
        className="scl--cms-components-statusBadge-dot"
        style={{ backgroundColor: config.dotColor }}
      />
      {label ?? config.label}
    </span>
  );
};

export default StatusBadge;